export default __webpack_public_path__ + "3e3f12423ec67a4fe23a917c898f4a95.svg";